module.exports = __webpack_public_path__ + "pen.png?9b0bacc6c0b9b3909e84b9afa256177c";